/**
 * The realtor's public site and a listing's page on it: the client portal at `/r/<alias>` (the
 * dashboard repo's portal/, served by Hosting and the server). Built in ONE place, so every share
 * button, copied link and the site settings' public address say the same thing; the server builds the
 * same listing link for Daniela (listingsSearch/listingHitLinks.ts). The old `/listings/u/<alias>` and
 * `/listings/<alias>/<id>` addresses 301 here (firebase.json), so links already sent keep working.
 *
 * Not dashboard routes: open them with a plain link or `window.open`, never the router.
 */

export const realtorSiteUrl = (alias: string, origin: string = window.location.origin): string =>
  `${origin}/r/${encodeURIComponent(alias)}`;

export const realtorSiteListingUrl = (alias: string, listingId: string, origin: string = window.location.origin): string =>
  `${realtorSiteUrl(alias, origin)}/l/${encodeURIComponent(listingId)}`;
